
// ***************************************************************************************************************************
// filename:    navigation.js
// author:      Jason Gilbert and Pawel Szajkowski
// created:     21-Aug-2014
// description: Provides the navigation logic/structures based on the ui-router plugin
// notes/mods:  n/a
// ***************************************************************************************************************************
    
export class MenuConfig {
    static $inject = ['MenuProvider'];
    constructor(MenuProvider) {

        MenuProvider.AddMenu('everyone', 'hostFamilies', {
            items: [
                {
                    name: 'How to find a host family',
                    state: 'app.hostFamilies.howToRespond'
                },
                {
                    name: 'Interested families',
                    state: 'app.hostFamilies.interestedFamilies',
                    visibility: ['applicationObservable', function (applicationObservable) {
                        return applicationObservable.toPromise().then(applicationInstance => {
                            return applicationInstance.status != 'OLA' &&
                                applicationInstance.status != 'AWA' &&
                                applicationInstance.status != 'PLC';
                        });
                    }]
                },
                {
                    name: 'Find my host family',
                    state: 'app.hostFamilies.findHostFamily',
                    visibility: ['applicationObservable', function (applicationObservable) {
                        return applicationObservable.toPromise().then(applicationInstance => {
                            return applicationInstance.status == 'TBM' && !applicationInstance.onHold && !applicationInstance.isPrematch;
                        });
                    }]
                    //visibility: ['Auth', function (Auth) {
                    //    return Auth.user && Auth.user.roleDetails && Auth.user.roleDetails.status == 'TBM' && !Auth.user.roleDetails.onHold
                    //}]
                },
                {
                    name: 'My choices',
                    state: 'app.hostFamilies.myChoices',
                    visibility: ['applicationObservable', function (applicationObservable) {
                        return applicationObservable.toPromise().then(applicationInstance => {
                            return applicationInstance.status == 'TBM' && !applicationInstance.onHold && !applicationInstance.isPrematch;
                        });
                    }]
                    //visibility: ['Auth', function (Auth) {
                    //    return Auth.user && Auth.user.roleDetails && Auth.user.roleDetails.status == 'TBM' && !Auth.user.roleDetails.onHold
                    //}]
                }
            ]
        });

        MenuProvider.AddMenu('everyone', 'hostFamiliesOffice', {
            items: [
                {
                    name: 'How to find a host family',
                    state: 'app.applications.hostFamilies.howToRespond'
                },
                {
                    name: 'Interested families',
                    state: 'app.applications.hostFamilies.interestedFamilies',
                    visibility: ['applicationObservable', function (applicationObservable) {
                        return applicationObservable.toPromise().then(applicationInstance => {
                            return applicationInstance.status != 'OLA' && 
                                applicationInstance.status != 'AWA' && 
                                applicationInstance.status != 'PLC';
                        });
                    }]
                },
                {
                    name: 'Find my host family',
                    state: 'app.applications.hostFamilies.findHostFamily',
                    visibility: ['applicationObservable', function (applicationObservable) {
                        return applicationObservable.toPromise().then(applicationInstance => {
                            return applicationInstance.status == 'TBM' && !applicationInstance.onHold && !applicationInstance.isPrematch;
                        });
                    }]
                },
                {
                    name: 'My choices',
                    state: 'app.applications.hostFamilies.myChoices',
                    visibility: ['applicationObservable', function (applicationObservable) {
                        return applicationObservable.toPromise().then(applicationInstance => {
                            return applicationInstance.status == 'TBM' && !applicationInstance.onHold && !applicationInstance.isPrematch;
                        });
                    }]
                }
            ]
        });

    }
}

angular
    .module('app')
    .config(MenuConfig);